import axios from 'axios';

export const boGetUserChallenges = search =>
  axios.get('/backoffice/proptrading/user_challenges/', { params: { ...search } }, {});

export const boGetUserChallenge = challengeId => axios.get(`/backoffice/proptrading/user_challenges/${challengeId}/`);

export const boIncreaseUserChallenge = challengeId =>
  axios.post(`/backoffice/proptrading/user_challenges/${challengeId}/increase/`);

export const boCloseUserChallenge = (challengeId, reason) =>
  axios.post(`/backoffice/proptrading/user_challenges/${challengeId}/close/`, {
    ...(reason ? { reason } : {}),
  });
